export interface GroupsCheckoutPassThroughParams {
  debug?: boolean
  testdata?: string
}

export const groupsCheckoutPassThroughParams = [
  'debug',
  'testdata',
] as (keyof GroupsCheckoutPassThroughParams)[]
